/**
 * Created by jmulder on 11/11/16.
 */

import {Cpu} from "./cpu";

export class Field {

    //private cpus: Cpu[];

    constructor(
        public $key: string,
        public name: string,        // name of field
        public description: string, // description of field
        public type: string,        // type of field
        public soll: number,
        public isOverboosted: boolean,
        public powerOnValue: number,
        public outputScalar: number,
        public cpus: Cpu[],
    ) {
    }

    static fromJson({$key, name, description, type, soll, isOverboosted, powerOnValue, outputScalar, cpus}) {
        //console.log(cpus);
        return new Field($key, name, description, type, soll, isOverboosted, powerOnValue, outputScalar, cpus);
    }

    static fromJsonArray(json : any[]) : Field[] {
        return json.map(Field.toField);
    }

    static jsonToField(json: any[]): Field {
      return Field.toField(json);
    }

    static toField(r:any): Field {

        let field = <Field>({
            $key: r.$key,
            name: r.name,
            description: r.description,
            type: r.type,
            soll: r.soll,
            isOverboosted: r.isOverboosted,
            powerOnValue: r.powerOnValue,
            outputScalar: r.outputScalar,
            cpus: Cpu.toCpuArray(r.cpus)
        });

        //console.log('Parsed field:', field);
        return field;
    }

}
